import { lazy } from 'react'

const CajasGestionApp = lazy(() => import('./view/CajasGestion'))

export const cajasRoutesMap = {
  gestion: {
    path: '/cajas/gestion',
    name: 'Gestión de Cajas',
  },
}

const cajasRoutes = [
  {
    path: cajasRoutesMap.gestion.path,
    name: cajasRoutesMap.gestion.name,
    element: <CajasGestionApp />,
  },
]
export default cajasRoutes
